import React, { FC } from 'react';
import { Stack, Switch, Typography } from '@mui/material';

interface SwitchProps {
  disabled: boolean;
  fieldName: string;
  labelRight?: string;
  labelLeft?: string;
  formik: any; // Making without a Formik prop will use FastField with context.
}

export const DefaultSwitch: FC<SwitchProps> = ({ disabled, fieldName, labelRight, labelLeft, formik }) => {
  return (
    <Stack direction="row" spacing={1} alignItems="center">
      {labelLeft && <Typography>{labelLeft}</Typography>}
      <Switch
        {...formik.getFieldProps(fieldName)}
        checked={formik.values[fieldName]}
        onChange={formik.handleChange}
        disabled={disabled}
        margin="normal"
        role="switch"
      />
      {labelRight && <Typography>{labelRight}</Typography>}
    </Stack>
  );
};
